import React from 'react';
import { IconButton, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import MuiDialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';

const StyledDialogTitle = styled(MuiDialogTitle)(({ theme }) => ({
  margin: 0,
  padding: theme.spacing(4.5, 4.5, 1.25),
}));

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  right: theme.spacing(1),
  top: theme.spacing(1),
  color: '#373737',
}));

export interface DialogTitleProps {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
}

export const DialogTitle = (props: DialogTitleProps) => {
  const { children, onClose, ...other } = props;
  return (
    <StyledDialogTitle {...other}>
      <Typography variant="h5" sx={{ color: '#373737', margin: 0 }}>
        {children}
      </Typography>
      {onClose ? (
        <StyledIconButton aria-label="close" onClick={onClose} size="large">
          <CloseIcon />
        </StyledIconButton>
      ) : null}
    </StyledDialogTitle>
  );
};
